import React from 'react';
import { classes, useRedirect } from '../../../../lib';
import Styles from './TrainingLogoBar.module.less';
import { Logotype } from '../../../Logotype';
import { Button } from '../../../Button';
import { TrainingDataType } from '../../../../lib/landingPage';
import { TrainingMenuMobile } from '../TrainingMenuMobile';
import { whatsappColdSales } from '../../../../constants/support';

export type TrainingLogoBarProps = {
    trainingMenu: TrainingDataType;
};

export const TrainingLogoBar = ({ trainingMenu }: TrainingLogoBarProps) => {
    const redirect = useRedirect();

    return (
        <div
            className={classes(
                'horizontal g8 py16 pr16 td-left-top m-left-middle',
                Styles.topBar
            )}>
            <div className={classes(Styles.logo, 'px24 m-hidden')}>
                {
                    <Logotype
                        type="WhiteSnowLogo"
                        clickable
                        onClick={() => redirect('/')}
                    />
                }
            </div>

            <div className="m-pl16">
                <TrainingMenuMobile trainingMenu={trainingMenu} showLogo />
            </div>

            <div className="horizontal wrap g8 flex-2 right-middle">
                <Button ghost href={whatsappColdSales} target="_blank">
                    Falar com um especialista
                </Button>
            </div>
        </div>
    );
};
